module.exports = __webpack_public_path__ + "img/Tariff_ID.afa170ab.jpg";